import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

/*
 * Full-resolution image viewer modal. Fit-to-screen by default; clicking the
 * image toggles 100% (actual pixels) with scrolling. ESC or backdrop closes.
 */
export default function ImageLightbox({ src, alt, caption, onClose }) {
  const [actualSize, setActualSize] = useState(false);
  const [natural, setNatural] = useState(null);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    // Freeze the page behind the overlay while open.
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose]);

  const onImgLoad = (e) => {
    setNatural({ w: e.target.naturalWidth, h: e.target.naturalHeight });
  };

  return createPortal(
    <div className="pim-lightbox" onClick={onClose} role="dialog" aria-modal="true">
      <button type="button" className="pim-lightbox-close" onClick={onClose} aria-label="Close">
        ✕
      </button>
      <div
        className={`pim-lightbox-stage ${actualSize ? 'actual' : 'fit'}`}
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={src}
          alt={alt || 'Full-size preview'}
          onLoad={onImgLoad}
          onClick={() => setActualSize((v) => !v)}
          title={actualSize ? 'Click to fit screen' : 'Click to view at 100%'}
        />
      </div>
      <div className="pim-lightbox-caption" onClick={(e) => e.stopPropagation()}>
        {caption && <span>{caption}</span>}
        {natural && (
          <span className="pim-lightbox-res">
            {natural.w}×{natural.h}px
          </span>
        )}
        <span className="pim-lightbox-hint">
          {actualSize ? 'Click image to fit screen' : 'Click image for 100% zoom'} · Esc to close
        </span>
      </div>
    </div>,
    document.body
  );
}
